import React from "react";
import FeatherIcon from "feather-icons-react";

// Compact Table Mode row - shared by TournamentsList/ClubsList (variant
// "tournaments"/"clubs") and LocationsList/PlayersDirectory (variant
// "entity"). One component instead of four near-identical blocks: the
// column layout differs per variant (grid-template-columns is keyed off
// `.trow-<variant>` in index.css), everything else - avatar circle, status
// dot, icon+value stats, actions slot - is identical markup/behavior.
// See frontend-tasks/2026-09-02-compact-table-mode.md.
// forwardRef - TournamentPlayers.js's infinite scroll observes the last
// rendered row's own DOM node directly (no separate sentinel div like the
// other 7 pages use), so it needs a real ref on the root element here.
export const CompactTableRow = React.forwardRef(({
    variant,
    // Caller-computed (a running index over just the data rows), not a CSS
    // nth-child - TournamentsList interleaves week/day divider elements
    // between rows, which would throw off nth-child's own count.
    zebra,
    statusDotClass,
    // Slot number / place (TournamentPlayers.js/TournamentRatingPlayers.js's
    // singles rows) - a separate leading column before the avatar, not
    // folded into `title`, so it lines up before the circle instead of
    // between the avatar and the name.
    indexLabel,
    avatarSrc,
    title,
    subtitle,
    stats = [],
    actions,
    onClick,
    className,
    ...rest
}, ref) => (
    <div className={`trow trow-${variant}${zebra ? " trow-odd" : ""}${className ? ` ${className}` : ""}`} onClick={onClick} ref={ref} {...rest}>
        {statusDotClass !== undefined && <span className={`status-dot ${statusDotClass || ""}`} />}
        {indexLabel !== undefined && <span className="trow-index">{indexLabel}</span>}
        <span className="trow-avatar">
            {avatarSrc && <img src={avatarSrc} alt="" />}
        </span>
        <span className="trow-name-text">
            {title}
            {subtitle && <span className="trow-subtitle"> · {subtitle}</span>}
        </span>
        {stats.map((stat, i) => (
            <span className={`row-stat ${stat.className || ""}`} key={i}>
                <FeatherIcon icon={stat.icon} />{stat.value}
            </span>
        ))}
        <span className="trow-actions" onClick={(e) => e.stopPropagation()}>
            {actions}
        </span>
    </div>
));
